export default __webpack_public_path__ + "static/media/sandClock.b632c039.svg";